import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_USER_IGNORED').plugin(axiosPlugin);

let fetchUserIgnoredAction = redux.fetchActionGetOne();

let createUserIgnoredAction = redux.fetchActionCreate();

let deleteUserIgnoredAction = redux.fetchActionDelete();

export const fetchUserIgnored = (userId, query = {}) => fetchUserIgnoredAction(`/users/me/users-ignored/${userId}?${queryString.stringify(query)}`);
export const createUserIgnored = (userId) => createUserIgnoredAction(`/users/me/users-ignored/${userId}`);
export const deleteUserIgnored = (userId = {}) => deleteUserIgnoredAction(`users/me/users-ignored/${userId}`);
export const resetUserIgnored = () => redux.actions.reset();

export const userIgnored = redux.reducer();